module.exports = __webpack_public_path__ + "media/img/ogp-ce336e7a6ee5261bf70859ef137a1030.png";